  <!--
  画面名：計画策定画面
  画面概要：計画策定の入力を行う
  備考： -
-->

<!-- HTML -->
<template>
  <!-- ページ全体を囲う要素  -->
  <div class="wrapper">
    <!-- pdf出力時のプログレスバー -->
    <div v-if="isProgress">
      <v-progress-linear v-model="progressStatus" />
    </div>

    <!-- 計画策定画面のセクション -->
    <section class="setting">
      <!-- ページタイトル -->
      <v-form
        ref="refTitleForm"
      >
        <v-flex xs4>
          <v-text-field
            v-model="title"
            class="pagetitle pt-3"
            :rules="[titleRules]"
            :disabled="isRefer"
            placeholder="計画書タイトル"
          />
        </v-flex>
      </v-form>
      <!-- ページ内コンテンツ -->
      <div class="content">
        <!-- 計画書が確定されている場合。右上にボタンを配置。 -->
        <v-layout class="buttons" v-if="isRefer">
          <!-- 戻るボタン -->
          <v-btn class="btn" :disabled="isOutput" @click="toPlanFormulation()" small>{{$language.LabelBack}}</v-btn>
          <!-- 編集ボタン -->
          <v-btn class="btn" :disabled="isOutput" @click="changeMode('edit')" small v-if="isAuth">{{$language.LabelEdit}}</v-btn>
          <!-- PDF出力ボタン -->
          <v-btn v-if="loadingPdf" class="btn" disabled small>PDF出力準備中</v-btn>
          <v-btn v-else class="btn" :disabled="isOutput" @click="outputPdf()" small>{{$language.LabelOutputPdf}}</v-btn>
        </v-layout>
        <!-- 計画書が未確定の場合。右上にボタンを配置。 -->
        <v-layout class="buttons" v-else>
          <!-- 戻るボタン -->
          <v-btn class="btn" @click="toPlanFormulation()" small>{{$language.LabelBack}}</v-btn>
          <!-- PDFの差し替え・付則設定ダイアログ表示ボタン -->
          <v-btn class="btn" @click="replaceAddedPlan()" small v-if="isAuth">{{'衛生管理計画書PDFの差し替え・付則を登録'}}</v-btn>
          <!-- 保存ボタン -->
          <v-btn class="btn" @click="save" small>{{$language.LabelSave}}</v-btn>
          <!-- 確定ボタン -->
          <v-btn :disabled="!(isCompleteOrganization && isCompleteFlowdiagram)" class="btn" @click="submit" small>{{$language.LabelFix}}</v-btn>
        </v-layout>

        <!-- 表示されている入力項目と入力ステップを表示 -->
        <v-layout>
          <v-flex xs3>
            <!-- 表示する入力項目を選択するセレクトボックス -->
            <v-select
              v-model="selected"
              :items="plans"
              menu-props="auto"
              label="Select"
              hide-details
              item-value="step"
              item-text="name"
              single-line
              outline
            />
          </v-flex>
          <v-flex flex>
            <!-- 入力ステップ -->
            <StepBar :Selected="selected" />
          </v-flex>
        </v-layout>
        <!-- セレクトボックスから選択された項目を表示 -->
        <div id="selectedArea">
          <!-- 体制データ入力 -->
          <Organization
            id="organize"
            style="background-color:#fff"
            v-show="selected === 'organize'"
            :isNew="isNew"
            :planId="planId"
            :title="title"
            :policy="policy"
            :organizationJson ="organizationJson"
            :organizationUserData="organizationUserData"
            :planCreateDate="planCreateDate"
            :isCopy="isCopy"
            :isRefer="isRefer"
            @sendId="sendId"
            @openSaveDialog="openSaveDialog"
            @openConfirmDialog="openConfirmDialog"
            @setCompleteOrganizationFalse="setCompleteOrganization(false)"
            ref="refOrganization"
          />
          <!-- フローダイアグラム選択 -->
          <FlowDiagram
            id="flowDiagram"
            style="background-color:#fff"
            v-show="selected === 'flowDiagram'"
            :isSetting="true"
            :isNew="isNew"
            :isRefer="isRefer"
            :planId="planId"
            :title="title"
            :isCopy="isCopy"
            :flowdiagramId="flowdiagramId"
            :planCreateDate="planCreateDate"
            @sendId="sendId"
            @openSaveDialog="openSaveDialog"
            @setCompleteFlowdiagramFalse="setCompleteFlowdiagram(false)"
            ref="refFlowDiagram"
          />
        </div>
      </div>
    </section>
    <!-- 計画書 -->
    <PlanBook
      id="planBook"
      :companyName="companyName"
      :first="planFixedDate"
      :update="planUpdateDate"
      class="planBook"
      />
    <!-- 保存用ダイアログ -->
    <SaveDialog
      :msg="msg"
      ref="saveDialog"
    />
    <!-- 確認用ダイアログ -->
    <ConfirmDialog
      :msg="confirmMsg"
      :isYes="true"
      ref="confirmDialog"
    />
    <!-- 計画書差し替え/付則ダイアログ -->
    <PlanDialog
      @afterSave="doneReplaceAddedPlan"
      :templatePlanDocName="templatePlanDocName"
      :replacePlanDocName="replacePlanDocName"
      :addedPlanDocName="addedPlanDocName"
      :isCopy="isCopy"
      :planId="planId"
      ref="planDialog"
    />
  </div>
</template>
<script src="../../../../src/assets/js/pdf-designer.js" type="text/javascript" ></script>

<script>
// 子（外部）コンポーネント読み込み
// ステップバー
import StepBar from '@/components/parts/common/StepBar'
// 体制データ入力
import Organization from '@/components/parts/managementFunction/Organization'
// フローダイアグラム選択
import FlowDiagram from '@/components/parts/managementFunction/FlowDiagram'
// 保存用モーダル
import SaveDialog from '@/components/parts/common/SaveDialog'
// 確認用モーダル
import ConfirmDialog from '@/components/parts/common/ConfirmDialog'
// 画面キャプチャ用
import html2canvas from 'html2canvas'
// PDF出力用
import JsPDF from 'jspdf'
// 文字コードエンコード用
import WebKoruri from '@/assets/json/webKoruri.json'
// 計画書コンポーネント
import PlanBook from '@/components/parts/systemConfig/PlanBook'
// 計画書差し替え・付則ダイアログコンポーネント isDialog
import PlanDialog from '@/components/parts/systemConfig/PlanningReplaceAddedDialog'
// PDF表示コンポーネント
import vuePdf from 'vue-pdf'

export default {
  name: 'Setting',
  // 使用コンポーネント
  components: {
    // ステップバー
    StepBar,
    // 体制データ入力
    Organization,
    // フローダイアグラム選択
    FlowDiagram,
    // 保存用モーダル
    SaveDialog,
    // 確認用モーダル
    ConfirmDialog,
    // 計画書表紙コンポーネント
    PlanBook,
    // 計画書差し替え・付則ダイアログコンポーネント
    PlanDialog,
    vuePdf
  },
  // コンポーネント内の変数を定義
  data () {
    return {
      // 計画書に記載する会社名
      companyName:'',
      // PDF出力ボタンを押下した際に表示されているページを格納する
      storageSelected:'',
      // arrPdfの配列を出力するための数字（arrPdfは再帰処理で呼び出されるため）
      num:0,
      // Pdf表示の際に必要なデータを格納
      arrayPdf : [],
      // Pdf初期設定
      initPdf: [],
      // プログレスバーの判定
      isProgress: false,
      // ダイアログ表示メッセージ
      msg: '',
      // 確認ダイアログ表示メッセージ
      confirmMsg:'',
      // 計画書ID
      planId: 0,
      // 計画書IDコピー時に、コピー元計画書のIDを設定
      oldPlanId: 0,
      // プログレスバーステータス
      progressStatus:0,
      // 計画書タイトル
      title: '',
      // 初期表示は体制データ入力に設定する
      selected: 'organize',
      // セレクトボックスで選択する計画書の項目を格納
      plans: [
        {
          // 体制データ入力
          name: this.$language.LabelInputOrganize,
          step: 'organize'
        },
        {
          // フローダイアグラム選択
          name: this.$language.LabelSelectedFlowDiagram,
          step: 'flowDiagram'
        }
      ],
      arrplanData:[],
      arrplanDataAdded:[],
      plan: [],
      // 新規作成判定
      isNew: true,
      // 確定ボタンのdisabled判定
      isFixed: false,
      // 過去の計画書からコピーされてきたかどうか判定
      isCopy: false,
      // 策定された計画書かどうか判定する
      status: 0,
      // 参照モード判定
      isRefer: false,
      // 計画書の名前
      planYear: '',
      // フローダイアグラムID
      flowdiagramId: 0,
      // フローダイアグラムjson
      flowdiagramJson: '',
      // フローダイアグラム名
      flowdiagramName: '',
      // 食品安全の方針
      policy: '',
      // 体制データjson
      organizationJson: '',
      // 体制データの担当等を格納
      organizationUserData: '',
      // 確認ダイアログに表示する文字
      confirmMessage: '',
      // 計画書を追加する際、最初に保存が押下された日時
      planCreateDate: '',
        // 最初に確定した年月日
      planFixedDate : '',
        // 確定済計画書が編集され再度確定した年月日
      planUpdateDate : '',
      // 確定ボタン押下時のフラグ
      isSubmit: false,
      // API実行回数
      accessCount: 0,
      // 権限判定
      isAuth: true,
      // PDFの左右のマージン
      marginLR:40,
      // PDF出力モード
      isOutput:false,
      // PDFの出力準備が完了しているか判定するフラグ
      loadingPdf:true,
      // 衛生管理計画書PDFの名前
      planDocName: null,
      // 雛形の衛生管理計画書PDFの名前
      templatePlanDocName: '',
      // 差し替え衛生管理計画書PDFの名前
      replacePlanDocName: '',
      // 衛生管理計画書付則PDFの名前
      addedPlanDocName: '',
      // 体制図のバリデートチェック結果のフラグ
      isCompleteOrganization: false,
      // フローダイアグラムのバリデートチェック結果のフラグ
      isCompleteFlowdiagram: false
    }
  },
  // 画面表示時に実行する関数を設定
  created () {
    // 権限チェック
    let auth = this.$store.getters['auth/getAuth'].auth
    if(auth === 5){
      this.isRefer = true
      this.isAuth = false
    }
    // パラメータを取得し、変数に格納する
    this.getParam()
    // 計画書PDFを取得
    this.selectPlan()
    // 事業者名を取得
    this.getCompanyName()
  },
  mounted() {
    // 計画を確定するための項目が入力済か確認する
    this.checkData()
    // 体制図のバリデートチェックを行う
    if (this.isCopy) {
      this.isCompleteOrganization = false
      this.isCompleteFlowdiagram = false
    } else {
      this.isCompleteOrganization = this.checkOrganization()
      this.isCompleteFlowdiagram = Boolean(this.flowdiagramId)
    }
    // 新規作成の場合、雛形の衛生管理計画書情報を取得
    if (this.isNew && !this.templatePlanDocName) {
      const self = this
      this.$store.dispatch('systemConfig/selectPlan', {
        isNameOnly: true,
        callback: response => {
          // 雛形計画書名を取得
          self.templatePlanDocName = response.data.planning_document_name
          self.planDocName = self.templatePlanDocName
          // プログレスバーを閉じる
          self.$store.dispatch('setIsLoading', false)
        }
      })
    }
  },
  watch: {
    status () {
      if (this.status === 20) {
        this.isRefer = true
      } else {
        // 店舗責任者の場合参照モード
        if(!this.isAuth){
          this.isRefer = true
        } else {
          this.isRefer = false
        }
      }
    }
  },
  // 関数群
  methods: {
    // 会社名を取得
    getCompanyName(){
      let self = this
      function callbackGetCompanyName(response){
        self.companyName = response[0].haccpcomname__c
        // プログレスバーを閉じる
        self.$store.dispatch('setIsLoading', false)
      }
      let data = {}
      data.callback = callbackGetCompanyName
      this.$store.dispatch('managementFunction/actionSelectCompanyName',data)
    },
    // 参照から編集に切り替える
    changeMode () {
      this.msg = ''
      this.status = 10
    },
    // タイトルのバリデーション
    titleRules () {
      if (this.title) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // パラメータを取得し、変数に格納する
    getParam () {
      if (this.$route.params.data) {
        // 編集/参照の場合
        this.planId = this.$route.params.data.id
        this.title = this.$route.params.data.title
        // 過去の計画書からコピーされた場合はisNewをtrueにする
        if (this.$route.params.data.isCopy) {
          this.isNew = true
          // 古いID
          this.oldPlanId = this.$route.params.data.oldId
        } else {
          this.isNew = false
        }
        this.isCopy = this.$route.params.data.isCopy
        // フローダイアグラムID
        this.flowdiagramId = this.$route.params.data.flowDiagramId
        // フローダイアグラムjson
        this.flowdiagramJson = JSON.parse(this.$route.params.data.flowDiagramJson)
        // フローダイアグラム名
        this.flowdiagramName = this.$route.params.data.flowDiagramName
        // 食品安全の方針
        this.policy = this.$route.params.data.foodSafetyPolicy
        // 体制データjson
        this.organizationJson = this.$route.params.data.organizationJson
        // 体制データの担当等を格納
        this.organizationUserData = this.$route.params.data.organizationUserData
        // 策定された計画書か判定
        this.status = this.$route.params.data.status
        // 計画書年度
        this.planYear = this.$route.params.data.year
        // 作成年月日
        this.planCreateDate = this.$route.params.data.createDate
        // 最初に確定した年月日
        this.planFixedDate = this.dateFormat(this.$route.params.data.fixedDate)
        // 確定済計画書が編集され再度確定した年月日
        this.planUpdateDate = this.dateFormat(this.$route.params.data.updateDate)
        // 雛形の衛生管理計画書PDFの名前
        this.templatePlanDocName = this.$route.params.data.templatePlanDocName
        // 差し替え衛生管理計画書PDFの名前
        this.replacePlanDocName = this.$route.params.data.replacePlanDocName
        // 衛生管理計画書PDFの名前
        this.planDocName = this.replacePlanDocName ? this.replacePlanDocName : this.templatePlanDocName
        // 衛生管理計画書付則PDFの名前
        this.addedPlanDocName = this.$route.params.data.addedPlanDocName
      } else {
        let date = new Date()
        // 計画書の年度
        this.planYear = date.getFullYear()
      }
    },
    // 取得した日付を年月日に置き換える
    dateFormat(value){
      if(!value)
      return null
      let date = new Date(value)
      return date.getFullYear() + '年' + Number(('00' + (date.getMonth() + 1)).slice(-2)) + '月' + Number(('00' + date.getDate()).slice(-2)) +'日'
    },
    // 計画を確定するための項目が入力済か確認する
    checkData () {
      if(
        this.checkOrganization() &&
        this.flowdiagramId &&
        !this.isNew
      ) {
        this.isFixed = true
        return true
      } else {
        this.isFixed = false
        return false
      }
    },
    checkOrganization () {
      let isNodata = false
      let arrayConcat = this.$refs.refOrganization.selection.concat(this.$refs.refOrganization.post,this.$refs.refOrganization.contact)
      for(let i = 0;i < arrayConcat.length; i++){
        if(arrayConcat[i] === ""){
          isNodata = true
          break
        }
      }
      return !isNodata && Boolean(this.$refs.refOrganization.inputPolicy)
    },
    // 戻るボタンが押下された際に発火。計画策定選択画面に遷移
    toPlanFormulation () {
      this.$router.push({ name: 'PlanFormulation' })
    },
    // DBに保存して保存用ダイアログを開く
    save () {
      // this.msg = ''
      let isTitle = this.$refs.refTitleForm.validate()
      if (isTitle) {
        if (this.selected === 'organize') {
          // コンポーネント：Organizationの保存処理を発火
          this.$refs.refOrganization.sendDB(isTitle, this.isCopy, this.oldPlanId)
        } else {
          // コンポーネント：Flowdiagramを保存する処理
          this.$refs.refFlowDiagram.sendDB(isTitle, this.isCopy, this.oldPlanId)
        }
      } else {
        // 結果NG、メッセージダイアログ表示
        this.openConfirmDialog()
      }
    },
    // 確定ボタン押下処理
    submit () {
      if(!(this.checkData())){
        return false
      }
      let self = this
      // 確定処理
      const submitExec = () => {
        let data = {}
        // コールバック関数を作成する
        function callbackSuccess () {
          // プログレスバーの非表示
          self.$store.dispatch('setIsLoading', false)
          self.isSubmit = true
          // 確定と同時にコピー状態を解除
          self.isCopy = false
          self.getSelectPlanById(true)
          self.selectPlan()
        }
        let date = new Date()
        let dateNow = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2)

        // 検索条件の設定
        data.id = self.planId
        // ステータス20:確定
        data.status = 20
        data.flowDiagramData = getClesingFlowDaigramJson()
        data.callback = callbackSuccess
        data.date = dateNow
        let isNew = true
        if(self.planFixedDate){
          isNew = false
        }
        data.isNew = isNew
        self.$store.dispatch('managementFunction/actionFixedPlan',data)

        // フローダイアグラムのjsonデータから整形してテーブル登録しやすいデータ形式で取得する
        function getClesingFlowDaigramJson () {
          let flowDiagramDatas = []
          // 要素の行分ループ
          for (let trCount = 0; trCount < self.flowdiagramJson.length; trCount++) {
            // 要素の作業分ループ
            for (let tdCount = 0; tdCount < self.flowdiagramJson[trCount].diagramBoxes.length; tdCount++) {
              let flowDiagramData = {}
              // 衛生管理計画IDとフローダイヤグラムIDは先に設定する
              flowDiagramData.hygiene_management_plan_id = self.planId
              flowDiagramData.flow_diagram_id = self.flowdiagramId
              // 作業BOXのIDと作業名を設定
              flowDiagramData.work_id = self.flowdiagramJson[trCount].diagramBoxes[tdCount].id
              flowDiagramData.work_name = self.flowdiagramJson[trCount].diagramBoxes[tdCount].title
              // 店舗マニュアルが設定されているかチェック
              if (self.flowdiagramJson[trCount].diagramBoxes[tdCount].manual.length < 1) {
                flowDiagramDatas.push(flowDiagramData)
                continue
              }
              let manuals = []
              for (let manualCount = 0; manualCount < self.flowdiagramJson[trCount].diagramBoxes[tdCount].manual.length; manualCount++) {
                manuals.push(String(self.flowdiagramJson[trCount].diagramBoxes[tdCount].manual[manualCount]))
              }
              flowDiagramData.template_manual_ids = manuals.join(',')
              flowDiagramDatas.push(flowDiagramData)
            }
          }
          return flowDiagramDatas
        }
      }
      if (this.isCompleteOrganization && this.isCompleteFlowdiagram) submitExec()
    },
    // 計画書が確定された場合のダイアログ表示処理
    donePlan () {
      // 確定ボタン押下時のみダイアログ等を表示
      if (!this.isSubmit) return
      this.msg = this.$language.MsgDonePlan
      this.$refs.saveDialog.openDialog()
      this.isSubmit = false
    },
    // 新規作成された計画書のIDを取得
    sendId (intId, organizationFlg, flowdiagramId) {
      this.planId = intId
      this.openSaveDialog(intId, organizationFlg, flowdiagramId)
    },
    // 保存用ダイアログを表示
    openSaveDialog (fromDialog, organizationFlg, flowdiagramId) {
      // 差し替え・付則ダイアログで保存押したときにコピー状態解除
      if (!organizationFlg && !flowdiagramId && this.isCopy) this.isCopy = false
      if (fromDialog) {
        this.$refs.planDialog.isManualDialog = false
      }
      // 体制図の保存時は体制図のバリデートチェックを行う
      if (organizationFlg) this.isCompleteOrganization = this.checkOrganization()
      // フローダイアグラムの保存時はフローダイアグラムのバリデートチェックを行う
      if (flowdiagramId !== void (0)) this.isCompleteFlowdiagram = Boolean(flowdiagramId)
      // saveDialogを取得
      this.$refs.saveDialog.openDialog()
      this.isNew = false
      this.getSelectPlanById()
    },
    setCompleteOrganization (flg) {
      this.isCompleteOrganization = flg
    },
    setCompleteFlowdiagram (flg) {
      this.isCompleteFlowdiagram = flg
    },
    // 衛生計画書を再度取得
    getSelectPlanById (fixedFlg) {
      let self = this
      // コールバック関数を呼び出す
      function callbackSetPlan (data) {
        self.planId = data[0].id
        self.organizationJson = data[0].organization_json_data
        self.organizationUserData = data[0].organization_user_data
        self.policy = data[0].food_safety_policy
        self.flowdiagramId = data[0].flow_diagram_id
        self.flowdiagramName = data[0].flow_diagram_name
        self.flowdiagramJson = JSON.parse(data[0].flow_diagram_json)
        self.status = data[0].status
        self.planCreateDate = data[0].create_date
        self.planFixedDate =  self.dateFormat(data[0].fixed_date)
        self.planUpdateDate = self.dateFormat(data[0].update_date)
        self.templatePlanDocName = data[0].template_planning_document_name
        if (fixedFlg) {
          // 確定時は差し替え・付則のPDF名を設定
          self.replacePlanDocName = data[0].replace_name
          self.addedPlanDocName = data[0].added_name
        }
        self.$forceUpdate()
        // 計画を確定するための項目が入力済か確認する
        self.checkData()
        self.donePlan()
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)

      }
      let data = {}
      data.id = this.planId
      data.callback = callbackSetPlan

      this.$store.dispatch('managementFunction/actionSelectPlan', data)
    },
    // 確認用ダイアログを表示
    openConfirmDialog (boolean) {
      if(boolean){
        this.confirmMsg = '入力に誤りがあります。'
      } else {
        this.confirmMsg = '計画書タイトルを入力してください。'
      }
      this.$refs.confirmDialog.openDialog()
    },
    // 計画書取得処理
    selectPlan () {
      const self = this
      // callback関数を呼び出し
      function callbackToArrayBuffer(response) {
        let pdfCount = response.data.length
        if (response.data[0]) {
          const reader = new FileReader()
          // 衛生管理計画書（雛形or差し替え）
          reader.readAsArrayBuffer(toBlob(response.data[0]))
          reader.onload = function (event) {
            self.arrplanData = reader.result
            self.loadingPdf = Boolean(--pdfCount)
          }
        }
        if (response.data[1]) {
          const reader = new FileReader()
          // 衛生管理計画書（付則）
          reader.readAsArrayBuffer(toBlob(response.data[1]))
          reader.onload = function (event) {
            self.arrplanDataAdded = reader.result
            self.loadingPdf = Boolean(--pdfCount)
          }
        }
      }
      // blobを作成する
      function toBlob (base64) {
        var bin = window.atob(base64)
        var buffer = new Uint8Array(bin.length)

        for (var i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i)
        }
        // Blobを作成
        try {
          var blob = new Blob([buffer.buffer], {
            type: 'application/pdf'
          })
        } catch (e) {
          return false
        }
        return blob
      }
      this.$store.dispatch('managementFunction/actionGetPlanningPdf', {
        replaceName: this.replacePlanDocName,
        addedName: this.addedPlanDocName,
        id: this.planId,
        callback: callbackToArrayBuffer
      })
    },

    // PDF出力処理
    outputPdf () {
      this.isOutput = true
      this.storageSelected = this.selected
      document.getElementById('selectedArea').classList.add("widthAdj")
      // PDF出力処理
      let arrPlanId = []
      arrPlanId.push('planBook')
      arrPlanId.push('organize')
      arrPlanId.push('flowDiagram')
      this.unit = Math.floor(100 / (this.addedPlanDocName ? 5 : 4))
      this.createPdf(arrPlanId)
    },
    // PDF初期化
    setPdfIni () {
      let webKoruri = ''
      let options = {}
      let objJsPDF
      // 文字エンコード情報挿入
      webKoruri = WebKoruri.text
      options = {
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts: true
      }
      // PDF初期化
      objJsPDF = new JsPDF('p', 'pt', 'a4', true)
      // PDFのフォント設定
      objJsPDF.addFileToVFS('WebKoruri.ttf', webKoruri)
      objJsPDF.addFont('WebKoruri.ttf', 'WebKoruri', 'regular')
      objJsPDF.setFont('WebKoruri', 'regular')
      return objJsPDF
    },
    // PDFの内容を設定
    createPdf (AarrPlanId) {
      // pdf初期化
      this.initPdf = this.setPdfIni()
      // プログレスバー動作開始
      this.isProgress = true
      this.progressStatus += this.unit
      // 計画書IDを取得
      let plandoc = AarrPlanId.shift()
      // htmlからcanvasを作成(1.0.0以上はonrenderedは使えないので注意)
      let element = ""
      // フローダイアグラムを読み込む場合は内部のflowBoxを対象にする
      if(plandoc === 'flowDiagram'){
        element = document.getElementById('flowBox')
      } else {
        // フローダイアグラム以外の場合
        element = document.getElementById(plandoc)
      }
      // htmlをcanvas（画像）に変換する
      html2canvas(element)
        .then(function (canvas) {
          // 計画書画像を出力
          this.setPlanImage(this.initPdf, canvas)
          if(plandoc === 'organize'){
            this.setText(this.initPdf, this.$language.LabelOrganizeContract)
          } else if(plandoc === 'flowDiagram'){
            this.setText(this.initPdf, this.$language.LabelFlowDiagram)
          }
          canvas = null
          // PDFのarraybufferをunit8arrayに変換
          let Stream = new Uint8Array(this.initPdf.output('arraybuffer'))
          // PDF結合用に変換（pdf-designer.js）
          this.arrayPdf[this.num] = new TPDFAnalyst()
          this.arrayPdf[this.num].LoadFromStream(Stream)
          // 表紙の次に計画書PDFを入れる
          if(plandoc === 'planBook'){
            this.num++
            let Stream = new Uint8Array(this.arrplanData)
            this.arrayPdf[this.num] = new TPDFAnalyst()
            this.arrayPdf[this.num].LoadFromStream(Stream)
            this.progressStatus += this.unit
            // 計画書PDFに付則があれば追加
            if (this.addedPlanDocName) {
              this.num++
              let Stream = new Uint8Array(this.arrplanDataAdded)
              this.arrayPdf[this.num] = new TPDFAnalyst()
              this.arrayPdf[this.num].LoadFromStream(Stream)
              this.progressStatus += this.unit
            }
          }
          this.initPdf = null
          return AarrPlanId
        }.bind(this))
        .then(function (AarrPlanId) {

          if (AarrPlanId.length > 0) {
            this.num++
            // JsPDFはブラウザに表示されている要素を取得しているので（display:noneの状態では取得できないので）、selectedを操作して表示を切り替える
            if(AarrPlanId[0] === 'organize'){
              this.selected = 'organize'
            } else if(AarrPlanId[0] === 'flowDiagram'){
              this.selected = 'flowDiagram'
            }

            // Vueの描画が終了した後にコールバックさせる
            this.$nextTick(function() {
              // callback
              this.createPdf(AarrPlanId)
            })
          } else {
            // ダウンロード実行処理
            this.run()
          }
        }.bind(this))
        .catch(function (reason) {
          // エラー発生ダイアログ表示
          this.msg = 'PDF出力に失敗しました。'
          this.$refs.saveDialog.openDialog()
          // エラー発生
          console.log(reason)
          // リセット
          this.resetletiable()
        }.bind(this))
    },
    openFaildDialog () {
      this.msg = '更新に失敗しました。時間を置いてもう一度お試しください。'
      this.$refs.saveDialog.openDialog()
    },
    // PDFに画像をセット
    setPlanImage (AinitPdf, canvas) {
      let format = 'JPEG'
      let wid = 0
      let hgt = 0
      let img = canvas.toDataURL('image/png', wid = canvas.width, hgt = canvas.height)
      let ratio = hgt / wid
      let fullWidth = AinitPdf.internal.pageSize.width
      let width = fullWidth - this.marginLR*2
      let height = width * ratio
      AinitPdf.addImage(img, format, this.marginLR, 90, width, height, '', 'FAST')
    },
    // PDFにテキストをセット
    setText (AinitPdf, title) {
      // 高さ調整
      AinitPdf.text(title, this.marginLR, 50)
    },
    // 各種変数のリセット
    resetletiable () {
      // pdfオブジェクトをクリア
      this.arrayPdf = []
      document.getElementById('selectedArea').classList.remove("widthAdj")
      // 保存していた選択画面をselectedに格納
      this.selected = this.storageSelected
      // 保存していた選択画面をリセット
      this.storageSelected = ''
      // プログレスバーを非表示にする
      this.isProgress = false
      // 進捗リセット
      this.progressStatus = 0
      this.num = 0
      // 各種変数をクリア
      this.initPdf = null
      // 出力モードを切り替える
      this.isOutput = false
    },

    // ダウンロード実行処理
    run() {
      let PDFCombine = new TPDFCombine()
      PDFCombine.SaveToFile(this.$language.LabelHygieneManagementPlan + '.pdf', this.arrayPdf)
      this.resetletiable()
    },

    // 衛生管理計画書の差し替え・付則を登録する
    replaceAddedPlan () {
      // バリデートチェック
      if (this.$refs.refTitleForm.validate()) {
        let data = {}
        // 衛生管理計画書PDFのファイル名
        data.templatePlanDocName = this.templatePlanDocName
        // 差し替え衛生管理計画書PDFのファイル名
        data.replacePlanDocName = this.replacePlanDocName
        // 衛生管理計画書付則PDFのファイル名
        data.addedPlanDocName = this.addedPlanDocName
        // 結果OK、差し替え・付則ダイアログ表示
        this.$refs.planDialog.openDialog()
      } else {
        // 結果NG、メッセージダイアログ表示
        this.openConfirmDialog()
      }
    },

    // 衛生管理計画書の差し替え・付則の登録後処理
    doneReplaceAddedPlan (data) {
      // IDを設定
      this.sendId(data.id)
      // 差し替え・付則PDFの名称を設定
      this.replacePlanDocName = data.replaceName
      this.addedPlanDocName = data.addedName
      // PDF再取得（出力準備）
      this.selectPlan()
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/managementFunction/setting.scss';
</style>
